import { Link, useSearchParams } from 'react-router-dom'

import Button from 'components/Button'
import { useReport2Query } from '../../../reports-list/reports-form-list/create-report_2/use-report-#-2'
import { ExportToCSV } from '../../../reports-list/utils-reports-actions'
import { Report2Table } from './table'

export const ViewReport2 = () => {
  const [searchParams] = useSearchParams()
  const searchQuery = JSON.parse(
    decodeURIComponent(searchParams.get('report-query')!)
  )
  const {
    data: report2Data,
    isLoading,
    isSuccess,
  } = useReport2Query(searchQuery)

  if (isLoading) return <div>Loading...</div>
  if (isSuccess && !report2Data) return <div></div>

  return (
    <div className="my-6">
      <div className="flex items-center gap-4">
        <button
          className="px-3 py-1 border rounded-md border-primary text-primary"
          type="button"
        >
          <Link
            to={`/reports-list?modal=report_2`}
            className="flex items-center gap-2"
          >
            {/* <CreateIcon size={16} /> */}
            <span className="tracking-wider font-light">Back to reports</span>
          </Link>
        </button>

        <Button
          type="button"
          // icon={faDownload}
          className="ml-1 rounded-lg tracking-wide font-bold"
          iconRight={false}
          onClick={() =>
            ExportToCSV(report2Data?.data || [], { filename: 'Report-2' })
          }
          // disabled={transactionsLoading ? true : false}
        >
          Download CSV Report
        </Button>
      </div>

      <br />

      <Report2Table tableData={report2Data?.data || []} />
    </div>
  )
}
